import { Component } from '@angular/core';
import { RouteParams } from '@angular/router-deprecated';
import { ReadinessService, LoadingService } from "../services";
import { InstitutionSetupModel } from "../models";

@Component({
    selector: 'sysreadiness',
    template: require('./readiness.html'),
    providers: [ReadinessService],
    directives: [],
})
export class ReadinessComponent {
    setupModel = new InstitutionSetupModel();

    constructor(
        protected svc: ReadinessService, 
        params: RouteParams, 
        protected loadingService: LoadingService
    ) {
        this.loadingService.startLoad();
        this.doStatusCheck(parseInt(params.get('id')));
    }

    doStatusCheck(id: number) {
        this.svc.checkStatus(id)
            .subscribe((response) => {
                Object.assign(this.setupModel, response);
                this.loadingService.stopLoad();
            });
    }
}


/** WEBPACK FOOTER **
 ** ./app/readiness/ReadinessComponent.ts
 **/